// connectionConst Copyright 2024 Rebecca L Beaudet
const PROD_HOSTNAME = 'thecomcollab.com';
const PROD_BACKEND_URL = `https://klk36ph6gc.execute-api.us-east-1.amazonaws.com/`;
const PROD = window.location.hostname === PROD_HOSTNAME ? true : false;
const BACKEND_URL = PROD ? PROD_BACKEND_URL : 'http://localhost:4242/';
const STRIPE_PUBLISHABLE_KEY = PROD
    ? 'pk_live_51KYcJEEbCI66dmtkaa4xPW59mdiDgYQFU9Xq3gAbHLeKOsubqbfCWGCpUfL8KX38oQLRqBKidlwgcMhmmeFWBSVK00QXc4sIpd'
    : 'pk_test_51KYcJEEbCI66dmtkZsX3D79xaLRJmUWYhY18FZ1G7PHNMIPktgHVg2SSKXTBljGgOQDdtvjAdMmySYdi1VmW5Uyo0068otpyI4';
const SIGN_UP_LAG = 7000; // in milliseconds
export { BACKEND_URL, STRIPE_PUBLISHABLE_KEY, SIGN_UP_LAG };
